import { isMobile } from 'react-device-detect';
import { isMobileWarningMessageBoxType } from '../types/mobileWarningTypes';
import { isDegradedMobileExperience } from './mobileUtils';
import { isLocalhostEnvironment } from './utils';
/**
 * Gets the overridden mobile device warning type for testing purposes (if any is set in URL and the environment allows it).
 */
function getForcedMobileWarningMessageBoxType() {
    if (!isLocalhostEnvironment()) {
        return;
    }
    const params = new URLSearchParams(window.location.search);
    const forcedMobileWarningMessageBoxType = params.get('forceMobileWarningType');
    if (isMobileWarningMessageBoxType(forcedMobileWarningMessageBoxType)) {
        return forcedMobileWarningMessageBoxType;
    }
}
export function getMobileWarningMessageBoxType() {
    const forcedMobileWarningMessageBoxType = getForcedMobileWarningMessageBoxType();
    if (forcedMobileWarningMessageBoxType) {
        return forcedMobileWarningMessageBoxType;
    }
    if (isDegradedMobileExperience()) {
        return 'pwa-warning';
    }
    if (isMobile) {
        return 'mobile-beta-warning';
    }
}
